const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type BehaviorCriteria = {
  '0': string;
  '1': string;
  '2': string;
  '3': string;
  '4': string;
};

export type BehaviorItemPositionCategory = 'general' | 'manager';

export type BehaviorItem = {
  id: number;
  item: string;
  def: string;
  weight: number;
  max: number;
  criteria: BehaviorCriteria;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchBehaviorItemList(options?: {
  positionCategory?: BehaviorItemPositionCategory;
  targetUserId?: string;
}) {
  const searchParams = new URLSearchParams({
    positionCategory: options?.positionCategory ?? 'manager',
  });
  if (options?.targetUserId) searchParams.set('targetUserId', options.targetUserId);
  const response = await fetch(`${apiBaseUrl}/api/admin/behavior-items?${searchParams.toString()}`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { items: BehaviorItem[] };
  return payload.items;
}

export async function replaceBehaviorItemList(input: {
  positionCategory: BehaviorItemPositionCategory;
  items: {
    id?: number;
    item: string;
    def: string;
    weight: number;
    max: number;
    criteria: BehaviorCriteria;
  }[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/behavior-items`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { items: BehaviorItem[] };
  return payload.items;
}
